import React from "react";

function Footer() {
  return (
    <>
      <div className="h-full w-screen bg-black/90 text-white ">
      <div className="pb-[100px] pt-[100px]">
      <div class="w-full border-t border-white"></div>
        <div className="p-[40px] flex gap-11 uppercase text-lg justify-between">
        <div className="col-span-2 sm:col-span-1">

          <ul className="mt-6 space-y-6 ">
            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                pre-owned{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                complaints{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                contact{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                whispers{" "}
              </a>
            </li>
          </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">

          <ul className="mt-6 space-y-6">
            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                cookies{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                find a dealer{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                privacy{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                language{" "}
              </a>
            </li>
          </ul>
          </div>
            <div className="col-span-2 sm:col-span-1">

          <ul className="mt-6 space-y-6">
          
            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                pressclub{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                eu tyre labels{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                careers{" "}
              </a>
            </li>
          </ul>
          </div>
            <div className="col-span-2 sm:col-span-1">

          <ul className="mt-6 space-y-6">
            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                legal{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                faqs{" "}
              </a>
            </li>

            <li>
              <a href="#" className=" transition hover:opacity-75">
                {" "}
                site map{" "}
              </a>
            </li>

          </ul>
          </div>
            
        
        </div>
        <div class="w-full border-t border-white"></div>
        </div>
      </div>
    </>
  );
}

export default Footer;
